import { useEffect } from "react";
import { App as CapApp } from "@capacitor/app";
import { useAuth } from "@/context/AuthContext";
import { isNativeApp, syncHealth } from "@/lib/health";

/** Pulls Apple Health / Health Connect data on app open and every resume. */
export default function NativeHealthSync() {
  const { user } = useAuth();

  useEffect(() => {
    if (!isNativeApp() || !user) return;
    syncHealth().catch(() => {});
    let handle;
    CapApp.addListener("appStateChange", ({ isActive }) => {
      if (isActive) syncHealth().catch(() => {});
    }).then((h) => { handle = h; });
    return () => { handle?.remove?.(); };
  }, [user]);

  return null;
}
